<style>
    .videoWrapper {
        position: relative;
        padding-bottom: 56.25%;
        /* 16:9 */
        padding-top: 25px;
        height: 0;
    }

    .videoWrapper iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0
    }
</style>
<input type="text" id="scriptHelper" class="sr-only">
<div class="main-content" *ngIf="!profile">
    <div class="loader"></div>
</div>

<div class="app-loading" *ngIf="loading">
    <div class="logo"></div>
    <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
    <p class="app-loading-message">{{loadingMessage}}</p>
</div>
<div class="main-content" *ngIf="profile">
    <div>
        <div id="vtex">
            <div class="row">
                <div class="col-md-12">
                    <h4 _ngcontent-c8="" class="card-title"><b _ngcontent-c8="">Programa de Indicação Polinizador</b>
                    </h4>
                    <div class="card">
                        <!-- <div class="card-header">
                            <h4 class="card-title">
                                <b>Ops, sua loja não está em uma plataforma já integrada ao Polen.</b>
                            </h4>
                        </div> -->
                        <div class="card-content">
                            <div class="lead">
                                <div>Seu link de compartilhamento:
                                    <br>
                                    <div class="form-group">
                                        <input type="text" id="referralLink"
                                            style="padding: 25px 30px; font-size: 20px;width:80%;cursor: pointer;background-color: #eee;color: #66615b;float:left"
                                            value="https://conteudo.polen.com.br/seja-bem-vindo-ao-polen?loja={{ profile.storeSeoName}}"
                                            class="form-control" disabled />
                                        <button type="button" class="btn btn-info btn-fill"
                                            (click)="copyToClipboard('referralLink')"
                                            style="padding: 14px;border-radius: 0 20px 20px 0px;margin-left: -5px;">Copiar</button>
                                    </div>
                                </div>
                                <div>Seu código de indicação:
                                    <br>
                                    <div class="form-group">
                                        <input type="text" id="codeHelper"
                                            style="padding: 25px 30px; font-size: 26px;font-weight: bold;width:50%;cursor: pointer;background-color: #eee;color: #66615b;float:left"
                                            value="{{ profile.storeSeoName}}" class="form-control" disabled />
                                        <button type="button" class="btn btn-info btn-fill"
                                            (click)="copyToClipboard('codeHelper')"
                                            style="padding: 14px;border-radius: 0 20px 20px 0px;margin-left: -5px;">Copiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Seus polinizadores</h4>
                        </div>
                        <div class="card-content">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="fresh-table">
                                        <table id="transactions"
                                            class="table table-striped table-no-bordered table-hover" cellspacing="0"
                                            width="100%" style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th>Data</th>
                                                    <th>Empresa</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let row of referralList">
                                                    <td>{{row.trialActivationDate | date:'dd/MM/yy' : 'UTC 0'}}</td>
                                                    <td>{{row.storeName}}</td>
                                                    <td>
                                                        <button *ngIf="!row.trialActive && row.activePayingUser"
                                                            class="btn btn-sm btn-success btn-fill btn-wd">cliente</button>
                                                        <button *ngIf="row.trialActive"
                                                            class="btn btn-sm btn-warning btn-fill btn-wd">em
                                                            teste</button>
                                                        <button *ngIf="!row.trialActive && !row.activePayingUser"
                                                            class="btn btn-sm btn-default btn-fill btn-wd">desativado</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">
                                <b>Como Funciona</b>
                            </h4>
                        </div>
                        <div class="card-content">
                            <p>São apenas dois passos para adicionar o script do Polen. </p>
                            <ul style="margin-left: 25px;">
                                <li>Adicionar o script no Google Tag Manager</li>
                                <li>Adicionar a chave de acesso para sua API</li>
                            </ul>
                            <p>Para facilitar, fizemos um vídeo rápido explicativo:</p>
                            <br>
                            <h4>Adicionando o Polen no seu Google Tag Manager</h4>
                            <div class="videoWrapper">
                                <iframe src="https://www.youtube.com/embed/WuVS3-bJowA" allowfullscreen></iframe>
                            </div>
                            <h4>Associando o GTM no admin da VTex</h4>
                            <p>Caso você já utilize o GTM, pode pular esse passo.</p>
                            <div class="videoWrapper">
                                <iframe src="https://www.youtube.com/embed/q7E16BdJPro" allowfullscreen></iframe>
                            </div>


                            <h4>Adicionar a chave de acesso para sua API</h4>
                            <div class="videoWrapper">
                                <iframe src="https://www.youtube.com/embed/pIRsIDL9jV0" allowfullscreen></iframe>
                            </div>
                            <br>
                            <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
                            <br>
                            <p>Ficou alguma dúvida ou está com dificuldades na integração?
                                <b>Nos chame no chat</b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>